import React, { useState } from 'react';
import { useToast } from "../../../hooks/use-toast";
import { ActivityFrequencyAxiosInstance } from "../../../Network/ActivityFrequencyAxiosInstance";

interface FileUploadProps {
  fetchItems?: () => Promise<void>;
}

const FileUpload: React.FC<FileUploadProps> = ({ fetchItems }) => {
  const [file, setFile] = useState<File | null>(null);
  const { toast } = useToast();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];
      setFile(selectedFile);
      handleUpload(selectedFile); // رفع تلقائي
    }
  };

  const handleUpload = async (selectedFile: File) => {
    const formData = new FormData();
    formData.append('file', selectedFile);

    try {
      const { data } = await ActivityFrequencyAxiosInstance.post("uploadFile", formData);
      
      const { success, message, errors } = data;

      if (success) {
        toast({
          title: "Success",
          description: message || "File uploaded successfully.",
        });

        if (fetchItems) {
          await fetchItems();
        }

        if (errors && errors.length > 0) {
          toast({
            title: "Errors Detected",
            description: errors.join('\n'),
            variant: "destructive",
          });
        }

        clearFile();
      } else {
        toast({
          title: "Failed",
          description: message || 'Failed to upload file',
          variant: "destructive",
        });
      }
    } catch (error) {
      toast({
        title: "Error",
        description: 'Failed to upload file',
        variant: "destructive",
      });
      console.error(error);
    }
  };

  const clearFile = () => {
    setFile(null);
    const input = document.getElementById('file-upload-frequency') as HTMLInputElement;
    if (input) input.value = '';
  };

  return (
    <div className="inline-flex items-center justify-center">
      <input
        id="file-upload-frequency"
        type="file"
        className="hidden"
        onChange={handleFileChange}
      />

      <label
        htmlFor="file-upload-frequency"
        className="w-10 h-10 bg-gradient-to-br from-blue-600 to-blue-700 
                   hover:from-blue-700 hover:to-blue-800
                   flex items-center justify-center rounded-full 
                   shadow-md cursor-pointer transition-all duration-200
                   active:scale-95 border border-blue-400/30"
        title="Upload File"
      >
        <i className="fa-solid fa-upload text-white text-xl"></i>
      </label>
    </div>
  );
};

export default FileUpload;